import { render, staticRenderFns } from "./BarrierList.vue?vue&type=template&id=53cf0162"
import script from "./BarrierList.vue?vue&type=script&lang=ts"
export * from "./BarrierList.vue?vue&type=script&lang=ts"
import style0 from "./BarrierList.vue?vue&type=style&index=0&id=53cf0162&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports